import React from "react";
import { formatDate } from "../../../util/formatters";

export const DateCell = ({ value }) => <>{formatDate(value)}</>;
